import { lazyLoad } from 'app/utils/loadable';

export const RiskRatingsPage = lazyLoad(
  () => import('./index'),
  module => module.RiskRatingsPage,
);
